import Container from "../../../components/element/container";
import { useTranslation } from "react-i18next";
import Icon from "../../../components/element/icon";

export default function PurchaseProgress({ currentStep, steps, onReview }) {
  const { t } = useTranslation();

  return (
    <Container tag="div" className="purchase-progress" aria-label="Purchase steps">
      {steps.map((step) => (
        <span
          className={`purchase-progress-step ${step.alert ? "require" : ""} ${step.submitted || step.number <= currentStep ? "active" : ""}`}
          key={step.number}
        >
          {/* The whole marker is the control, so the title and hint are part of
              the hit area rather than the number alone. */}
          {step.submitted || step.alert ? (
            <button
              type="button"
              className="purchase-progress-marker purchase-step-review-button"
              aria-label={`${step.alert ? "Sign" : "Review"} step ${step.number}: ${step.title}`}
              title={`${step.alert ? "Sign" : "Review"} ${step.title}`}
              onClick={() => onReview(step.number)}
            >
              <b>
                {step.alert ? (
                  <Icon icon="solar:danger-circle-bold" />
                ) : (
                  step.number
                )}
              </b>
              <small className="purchase-progress-title">{t(step.title)}</small>
              <small className="purchase-progress-action">
                {t(step.actionLabel || "Tap to review")}
              </small>
            </button>
          ) : (
            <span className="purchase-progress-marker">
              <b
                aria-current={step.number === currentStep ? "step" : undefined}
              >
                {step.number}
              </b>
              <small className="purchase-progress-title">{t(step.title)}</small>
            </span>
          )}
          {step.number < 3 && <i />}
        </span>
      ))}
    </Container>
  );
}
